import type { jsPDF } from "jspdf";
import { EXO2_REGULAR_BASE64 } from "./fonts/exo2Regular";
import { EXO2_SEMIBOLD_BASE64 } from "./fonts/exo2Semibold";

/* The design sets every string in the offer on Exo 2 (`H3`/`H4` are Exo 2
 * SemiBold; the body sizes match Exo 2 Regular widths), which is also the UI font
 * of the configs that produce the offer.
 *
 * The two payloads are static instances cut from `public/fonts/exo2-variable-*`:
 * jsPDF's parser wants a plain TTF, so a woff2 variable font cannot be handed to
 * it, and neither fontsource subset covers Czech on its own (`latin` has á/í,
 * `latin-ext` has č/ř/ž). Rebuild them with fontTools when the brand font
 * changes — merge the two subsets, instantiate at `wght` 400 and 600, subset to
 * `U+0020-007E,U+00A0-00FF,U+0100-017F` plus punctuation, then base64 the result
 * into `fonts/exo2*.ts`. They are ~29 KB each before encoding.
 *
 * Committed as base64 rather than imported from a `.ttf` because both bundler
 * routes fail somewhere: `?inline` yields a plain URL under the dev server (jsPDF
 * then feeds it to `atob` and throws), while `?url` emits a sidecar asset that the
 * single-file widget build cannot fetch cross-origin. A string in the module graph
 * behaves identically in dev, in both builds and under Node.
 */
export const PDF_FONT = "Exo2";

export function registerPDFFonts(doc: jsPDF): void {
  doc.addFileToVFS("Exo2-Regular.ttf", EXO2_REGULAR_BASE64);
  doc.addFont("Exo2-Regular.ttf", PDF_FONT, "normal");
  doc.addFileToVFS("Exo2-SemiBold.ttf", EXO2_SEMIBOLD_BASE64);
  doc.addFont("Exo2-SemiBold.ttf", PDF_FONT, "bold");
}
